import { render, staticRenderFns } from "./RutaEcopetrolIndex.vue?vue&type=template&id=49659da4"
import script from "./RutaEcopetrolIndex.vue?vue&type=script&lang=js"
export * from "./RutaEcopetrolIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports